<template>
  <v-layout column class="pagemargin page">
    <!--TITLE BAR -->
    <v-layout row wrap class="noprint">
      <v-flex md12>
        <v-toolbar color="secondary">
          <v-toolbar-title class="font-weight-thin white--text">
            Print Report for
            <strong>{{gName}}</strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="printPage" dark right large class="icons8-pdf"></v-icon>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <div id="printMe" class="printWrapper">
      <div class="printonly" style="page-break-after: always; max-width: 700px !important;">
        <!-- LOGO -->
        <p align="center">
          <img
            style="max-width: 40%;"
            :src="require('@/assets/colour-logo-transparent-bg.png')"
            class="printonly"
          />
        </p>
        <!-- FIXTURE INFO -->
        <div style="display:inline-block !important;">
          <h3 style="text-align: center; margin-top: 15%;">Fixture details</h3>

          <table
            border="1"
            style="margin-top: 2% !important; width: 300px !important; display:inline-block !important;"
          >
            <tr>
              <td class="more-info-title primary--text">Competition:</td>
              <td>{{game.competition}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Fixture:</td>
              <td>{{game.gameName}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Result:</td>
              <td>{{game.result}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Venue:</td>
              <td>{{game.venue}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Attendence:</td>
              <td>{{game.attendence}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Broadcast Channel:</td>
              <td>{{game.tvChannel}}</td>
            </tr>
            <tr>
              <td class="more-info-title primary--text">Viewing Figures:</td>
              <td>{{game.viewing}}</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- Charts -->
      <div class="printChart" style="page-break-after: always; max-width: 700px !important;">
        <h3>Top 5 Sponsors by Air Time</h3>
        <v-divider style="margin: 0px 20px 0px 20px !important" />
        <SponsorsByAirTime />
      </div>
      <div class="printChart" style="page-break-after: always; max-width: 700px !important;">
        <h3>Top 5 Locations by Air Time</h3>
        <v-divider style="margin: 0px 20px 0px 20px !important" />
        <LocationsByAirTime />
      </div>
      <div class="printChart" style="page-break-after: always; max-width: 700px !important;">
        <h3>Top 5 by Ad Frequency</h3>
        <v-divider style="margin: 0px 20px 0px 20px !important" />
        <SponsorsByAdFrequency />
      </div>
      <div class="printChart" style="max-width: 700px !important;">
        <h3>Top 5 Sponsors by Dwell Time</h3>
        <v-divider style="margin: 0px 20px 0px 20px !important" />
        <SponsorsByDwellTime />
      </div>
       <!--/Charts-->
    </div>
   

    <div style="height: 50px !important" class="noprint"></div>
    <!-- bottom navigation -->
    <v-bottom-nav app :active.sync="bottomNav" :value="true" fixed color="white" class="noprint">
      <v-btn color="primary" value="recent" flat v-on:click="backToGames()">
        <span color="primary">Back</span>
        <v-icon color="primary">icons8-sort-left</v-icon>
      </v-btn>
      <v-btn color="primary" value="home" flat v-on:click="backToGames()">
        <span>Games</span>
        <v-icon>icons8-stadium</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-layout>
</template>

<script>
import SponsorsByAirTime from "@/components/charts/SponsorsByAirTime.vue";
import LocationsByAirTime from "@/components/charts/LocationsByAirTime.vue";
import SponsorsByAdFrequency from "@/components/charts/SponsorsByAdFrequency.vue";
import SponsorsByDwellTime from "@/components/charts/SponsorsByDwellTime.vue";

import Vue from "vue";
import { mapState } from "vuex";

export default {
  name: "ViewFirstGamePrintReport",
  components: {
    SponsorsByAirTime,
    LocationsByAirTime,
    SponsorsByAdFrequency,
    SponsorsByDwellTime
  },
  data() {
    return {
      active: null,
      bottomNav: "home",
      games: [],
      portalList: [],
      selected: "",
      secondselected: "",
      output: null,
      game: []
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      Portals: state => state.Admin.Portals,
      Documents: state => state.Admin.Documents,
      gameID: state => state.game.gameID,
      gName: state => state.report.gameName,
      gID: state => state.report.gameID,
      DocByID: state => state.Admin.DocByID
    })
  },
  watch: {
    portal: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    Portals: {
      handler: function() {
        this.portalList = this.Portals;
      },
      deep: true
    },
    Documents: {
      handler: function() {
        this.games = this.Documents;
      },
      deep: true
    },
    DocumentResult: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    DocByID: {
      handler: function() {
        this.game = this.DocByID;
      },
      deep: true
    },
    DocResultByID: {
      handler: function() {
        this.readOneGame();
      },
      deep: true
    },
    loading(val) {
      if (!val) return;
      setTimeout(() => (this.loading = false), 2000);
    }
  },
  methods: {
    printPage() {
      window.print();
    },
    initializePage() {
      // first game
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.gID,
        "Admin/setDocByID"
      ]);
      var i = 0;
      var gameName = "";
      for (i = 0; i < this.Documents.length; i++) {
        if (this.gID === this.Documents[i].id) {
          gameName = this.Documents[i].gameName;
          this.$store.commit("report/setValue", ["gameName", gameName]);
        }
      }
    },
    readGames() {
      this.$store.dispatch("Admin/readDocuments", [
        "games",
        this.portal.active.id,
        "Admin/setDocuments"
      ]);
    },
    readOneGame() {
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.gID,
        "Admin/setDocByID"
      ]);
    },
    backToGames() {
      this.$router.push("/comparisonreport");
    },
    redirectToPrint() {
      this.$htmlToPaper("printMe", () => {
        // console.log("Printing done or got cancelled!");
      });
    }
  },
  mounted() {
    this.$emit("navOpen", false);
    this.readGames();
    this.initializePage();
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  }
};
</script>

<style>
.select-container {
  position: relative;
  z-index: 2;
  margin-top: 10%;
}

.comparison-title {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.report-titles {
  margin-top: 30px !important;
}
.printonly {
  display: none;
}

.printWrapper {
  width: 100%;
  margin: auto;
  text-align: center;
  position: relative;
  float: none;
}

.printChart {
  display: inline-block;
  width: 100%;
}

@media print {
  h3 {
    page-break-before: auto;
    font-size: 25px !important;
  }
  .newpage {
    color: pink !important;
  }
  .printonly {
    display: block;
  }
  .printChart{
    display: block !important;
  }

  @page {
    /*  margin-top: 20cm;
  margin-bottom: 30cm;
  margin-left: 30cm;
  margin-right: 20cm;
*/
  }
}
</style>

